<template>
    <form @submit.prevent="submit" class="fuid-border-bottom fuid-alumno">

        <b-row>

            <b-col cols="12">

                <errorFromServer :id="id" />

            </b-col>

        </b-row>

        <b-row>

            <b-col cols="12" md="6" lg="4">

                <div class="fuid-chra-box ini" @click.prevent="changeform(1)">

                    <input type="radio" :id="`antiguo-radio-no${id}`" :name="`antiguo-radio-no${id}`"
                        v-model="fields.antiguo" :value="1">
                    <label :for="`antiguo-radio-no${id}`" class="d-flex align-items-center"><strong>{{
                        $t('forms.student.no') }}</strong></label>

                </div>

            </b-col>

            <b-col v-if="getLocalizacion[0].antiguoAlumno" cols="12" md="6" lg="8">

                <div class="fuid-chra-box ini" @click.prevent="changeform(2)">
                    <input type="radio" :id="`antiguo-radio-si${id}`" :name="`antiguo-radio-si${id}`"
                        v-model="fields.antiguo" :value="2">
                    <label :for="`antiguo-radio-si${id}`" class="d-lg-flex align-items-center fuid-radio-ini"><strong>{{
                        $t('forms.student.si') }}</strong><span>{{ $t('forms.student.si2') }}</span></label>
                </div>
            </b-col>
        </b-row>

        <b-row v-if="fields.antiguo == 0" class="fuid-form-to-render">

            <fakeForm cols="6" lg="4" />

            <fakeForm cols="6" lg="4" />

            <fakeForm cols="6" lg="4" />

            <fakeForm cols="6" lg="4" />

            <fakeForm cols="6" lg="4" />

            <fakeForm cols="6" lg="4" />

            <fakeForm cols="6" lg="12" />
        </b-row>

        <b-row v-if="fields.antiguo == 1" class="fuid-form-to-render">

            <b-col cols="12">

                <b-row>

                    <b-col cols="12" md="6" lg="4" class="fuid-form-group"
                        :class="{ 'form-group--error': $v.fields.nombre.$error }">

                        <label class="fuid-form__label">{{ $t('forms.student.nombre') }}<span
                                class="fuid-required_ask">*</span></label>
                        <input class="fuid-form__input" v-model.trim="$v.fields.nombre.$model" />
                        <div class="error-c error" v-if="!$v.fields.nombre.required">{{ $t('forms.required') }}</div>
                        <div class="error-c error" v-if="!$v.fields.nombre.minLength">{{ $t('forms.min', {
                            length:
                                $v.fields.nombre.$params.minLength.min
                        }) }}</div>

                    </b-col>

                    <b-col cols="12" md="6" lg="4" class="fuid-form-group"
                        :class="{ 'form-group--error': $v.fields.apellidos.$error }">

                        <label class="fuid-form__label">{{ $t('forms.student.apellidos') }}<span
                                class="fuid-required_ask">*</span></label>
                        <input class="fuid-form__input" v-model.trim="$v.fields.apellidos.$model" />
                        <div class="error-c error" v-if="!$v.fields.apellidos.required">{{ $t('forms.required') }}</div>
                        <div class="error-c error" v-if="!$v.fields.apellidos.minLength">{{ $t('forms.min', {
                            length:
                                $v.fields.apellidos.$params.minLength.min
                        }) }}</div>

                    </b-col>

                    <b-col cols="12" md="6" lg="4" class="fuid-form-group"
                        :class="{ 'form-group--error': $v.fields.dni.$error }">

                        <label class="fuid-form__label">{{ $t('forms.student.dni') }}</label>
                        <input class="fuid-form__input" v-model.trim="$v.fields.dni.$model" />
                        <div class="error-c error" v-if="!$v.fields.dni.dni">{{ $t('forms.dni') }}</div>

                    </b-col>

                </b-row>

                <b-row>

                    <b-col cols="12" md="6" lg="4" class="fuid-form-group">

                        <label class="fuid-form__label">{{ $t('forms.student.telefono') }}</label>
                        <input class="fuid-form__input" v-model="fields.telefono" />

                    </b-col>

                    <b-col cols="12" md="6" lg="4" class="fuid-form-group"
                        :class="{ 'form-group--error': $v.fields.fechaNacimiento.$error }">

                        <label class="fuid-form__label">{{ $t('forms.student.nacimiento') }}<span
                                class="fuid-required_ask">*</span></label>

                        <div class="d-flex">

                            <select :placeholder="$t('forms.datepicker.day')" class="fuid-form__input fuid-form__selbirth"
                                v-model="fields.fechaNacimientoDia" name="dia" id="dia" @change.prevent="calculateBirth">

                                <option :value="undefined" selected disabled hidden>{{ $t('forms.datepicker.day') }}
                                </option>
                                <option v-for="(day, index) in 31" :key="index" :value="day">{{ day }}</option>

                            </select>

                            <select class="fuid-form__input fuid-form__selbirth fuid-form__selbirthm"
                                v-model="fields.fechaNacimientoMes" name="mes" id="mes" @change.prevent="calculateBirth">

                                <option :value="undefined" selected disabled hidden>{{ $t('forms.datepicker.month') }}
                                </option>
                                <option v-for="(month, index) in 12" :key="index" :value="index">{{ $t(`forms.months.${index
                                    + 1}`) }}</option>

                            </select>

                            <select class="fuid-form__input fuid-form__selbirth fuid-form__selbirthy"
                                v-model="fields.fechaNacimientoAnio" name="anio" id="anio" @change.prevent="calculateBirth">

                                <option :value="undefined" selected>{{ $t('forms.datepicker.year') }}</option>
                                <option v-for="(year, index) in selectAnios" :key="index" :value="year.value">{{ year.value
                                }}
                                </option>

                            </select>

                        </div>

                        <div class="error-c error" v-if="!$v.fields.fechaNacimiento.required">{{ $t('forms.required') }}
                        </div>

                    </b-col>

                    <b-col v-if="fields.fechaNacimiento" :class="{ 'form-group--error': $v.fields.alumno_idiomas.$error }"
                        cols="12">

                        <h4 class="fuid-form__tit">{{ $t('languages.tit') }}</h4>

                        <div v-for="(idioma, index) in getIdiomasFront" :key="index"
                            class="fuid-chra-box fuid-lang-pick d-block d-lg-inline-block">
                            <input type="checkbox" :id="`idioma-radio-no${index}-${formid}`"
                                :name="`idioma-radio-no${index}-${formid}`" v-model.trim="$v.fields.alumno_idiomas.$model"
                                :value="idioma">
                            <label :for="`idioma-radio-no${index}-${formid}`" class="d-flex align-items-center">{{
                                idioma.idioma.nombre }}</label>
                        </div>

                        <div class="error-c error" v-if="!$v.fields.alumno_idiomas.required">{{ $t('forms.required') }}
                        </div>

                    </b-col>

                </b-row>

            </b-col>

        </b-row>

        <b-row v-if="fields.antiguo == 2" class="fuid-form-to-render">

            <b-col cols="12">

                <b-row>

                    <b-col cols="12" md="6" lg="4" class="">

                        <label class="fuid-form__label">{{ $t('forms.student.numeroAlumno') }}</label>

                    </b-col>

                </b-row>

                <b-row>

                    <b-col cols="12" md="6" lg="4" class="fuid-form-group">

                        <input class="fuid-form__input" v-model.trim="alumnoNumero" />

                        <div class="error-c">

                            <div class="error error--visible" v-if="personaCheckError">{{ $t('forms.student.checkError') }}
                            </div>
                            <div class="success" v-if="personaValidated"
                                :class="{ 'form-group--error': $v.fields.alumno_idiomas.$error }">

                                {{ $t('forms.student.validated') }}

                            </div>

                        </div>

                    </b-col>

                    <b-col cols="12" md="6" lg="4" class="fuid-form-group d-flex">

                        <button @click.prevent="alumnoNumeroCheck" class="fuid-button-check">

                            <b-spinner v-if="personaChecking" label="Loading..."></b-spinner>

                            <span v-else>{{ $t('forms.student.check') }}</span>

                        </button>

                    </b-col>

                </b-row>

                <b-row v-if="personaValidated">

                    <b-col cols="12" class="fuid-form-group fuid-form-group__nomb fuid-form-group__nopb"
                        :class="{ 'form-group--error': $v.fields.alumno_idiomas.$error }">

                        <h4 class="fuid-form__tit">{{ $t('languages.tit') }}</h4>

                        <div v-for="(idioma, index) in getIdiomasFront" :key="index"
                            class="fuid-chra-box fuid-lang-pick d-block d-lg-inline-block">

                            <input type="checkbox" :id="`idioma-radio-no${index}-${formid}`"
                                :name="`idioma-radio-no${index}-${formid}`" v-model.trim="$v.fields.alumno_idiomas.$model"
                                :value="idioma">
                            <label :for="`idioma-radio-no${index}-${formid}`" class="d-flex align-items-center"><strong>{{
                                idioma.idioma.nombre }}</strong></label>

                        </div>

                        <div class="error-c error" v-if="!$v.fields.alumno_idiomas.required">{{ $t('forms.required') }}
                        </div>

                    </b-col>

                </b-row>

            </b-col>

        </b-row>

        <b-row v-if="alumnoEdad && fields.antiguo == 1">

            <b-col cols="12">

                <div class="fuid-alert fuid-alert-1 fuid-age-alert" v-for="(idioma, index) in fields.alumno_idiomas"
                    :key=(index)>

                    <p v-if="alumnoEdad < idioma.edadMin">{{ $t('forms.student.alert_lanm_1') }} {{
                        $t(`languages.${getIdiomasCode(idioma.idioma.id)}`) }} {{ $t('forms.student.alert_lanm_3', {
        age:
            idioma.edadMin
    }) }}</p>

                    <p v-else-if="idioma.pruebaNivel && edadPrueba(idioma)">{{ $t('forms.student.alert_en') }}</p>

                </div>

            </b-col>

        </b-row>

    </form>
</template>

<script>
// ----------------------------------------------------------
// To map shit from Vuex
// ----------------------------------------------------------
import { mapActions } from 'vuex'
import { mapGetters } from 'vuex'
// ----------------------------------------------------------
// Validators for vuelidate
// ----------------------------------------------------------
import { required, requiredIf, minLength, between } from 'vuelidate/lib/validators'
import dni from '@/mixins/validatorDni'
// ----------------------------------------------------------
// For get niveles
// ----------------------------------------------------------
import { getNivel } from "@/api/niveles.api"
// ----------------------------------------------------------
// Components
// ----------------------------------------------------------
import errorFromServer from '@/components/errorFromServer'
import fakeForm from '@/components/fakeForm'
// ----------------------------------------------------------
// Mixins
// ----------------------------------------------------------
import scrollTo from '@/mixins/scrollTo'

export default {

    props: {

        'id': {
            type: Number,
            default: 0,
            required: true
        }

    },

    components: {

        errorFromServer,
        fakeForm

    },

    mixins: [scrollTo],

    /*
    mounted() {

        this.scrollToError()

    },
    */

    data() {

        return {
            formid: this.id,
            alumnoId: null,
            alumnoNumero: '',
            personaCheckError: false,
            personaChecking: false,
            personaValidated: null,
            personaPrevious: null,
            alumnoFromApi: false,
            name: '',
            englishCode: 2,
            alumnoInPrematricula: false,
            validation_form: false,
            validation_edad_idiomas: false,
            validation_form_toparent: false,
            f: null,
            fields: {
                antiguo: 0,
                nombre: '',
                apellidos: '',
                dni: '',
                telefono: '',
                pr: '',
                fechaNacimiento: '',
                fechaNacimientoDia: undefined,
                fechaNacimientoMes: undefined,
                fechaNacimientoAnio: undefined,
                alumno_idiomas: []
            },
            levels: []
        }

    },

    validations() {

        /**
         * Conditional validations
         *
         */

        if (this.fields.antiguo == 1) {

            this.f = {

                fields: {
                    nombre: {
                        required,
                        minLength: minLength(3)
                    },
                    apellidos: {
                        required,
                        minLength: minLength(3)
                    },
                    fechaNacimiento: {
                        required
                    },
                    alumno_idiomas: {
                        required,
                        minLength: minLength(1)
                    },
                    dni: {}
                }

            }

        } else if (this.fields.antiguo == 2) {

            this.f = {

                fields: {

                    alumno_idiomas: {
                        required,
                        minLength: minLength(1)
                    }

                }

            }

        }

        /* Remove DNI validation
        if (this.fields.dni !== '') {

            this.f.fields.dni = {

                dni

            }

        }
        */

        return this.f

    },

    computed: {

        ...mapGetters('Localizaciones', ['getIdiomasFront']),
        ...mapGetters('Localizaciones', ['getIdiomasCode']),
        ...mapGetters('Localizaciones', ['getLocalizacion']),
        ...mapGetters('Prematricula', ['getCurso']),

        /**
         * Calculate age
         * Year based no months involved
         *
         */

        alumnoEdad: function () {

            if (typeof this.fields.fechaNacimientoDia !== 'undefined' && typeof this.fields.fechaNacimientoMes !== 'undefined' && typeof this.fields.fechaNacimientoAnio !== 'undefined') {

                let today = new Date()
                let birthDate = new Date(this.fields.fechaNacimientoAnio, this.fields.fechaNacimientoMes, this.fields.fechaNacimientoDia, 12, 0, 0, 0)
                let age = today.getFullYear() - birthDate.getFullYear()

                return age

            } else {

                return false

            }

        },

        /**
         * Generate years for select
         *
         */

        selectAnios() {

            let anios = []

            let currentYear = new Date().getFullYear()

            for (let i = 0; i < 100; i++) {

                anios.push({ value: currentYear - i })

            }

            return anios

        }

    },

    methods: {

        /**
         * Map actions from Vuex
         *
         */

        ...mapActions('Personas', ['checkPersona']),
        ...mapActions('Personas', ['checkPersonaReferencia']),
        ...mapActions('Personas', ['createPersona']),
        ...mapActions('Personas', ['putPersona']),
        ...mapActions('Personas', ['setPersona']),
        ...mapActions('Prematricula', ['setAlumnosData']),
        ...mapActions('Prematricula', ['removeAlumnoData']),
        ...mapActions('Prematricula', ['checkAlumnoPrematricula']),

        /**
        * Check if age is within the levels age range for selected language
        *
        */
        edadPrueba(idioma) {
            let levels = []
            for (let index = 0; index < this.getLocalizacion[0].niveles.length; index++) {
                let level = this.getLocalizacion[0].niveles[index];
                if (level.idioma.id == idioma.id) levels.push({ edadMin: level.edadMin, edadMax: level.edadMax, prueba: false })
                for (let index = 0; index < levels.length; index++) {
                    let level = levels[index];
                    if (level.edadMin <= this.alumnoEdad && this.alumnoEdad <= level.edadMax) level.prueba = false
                    else level.prueba = true
                }
            }
            for (let index = 0; index < levels.length; index++) {
                let level = levels[index];
                console.log(level, this.alumnoEdad)
                if (!level.prueba) return false
            }
            return true
        },

        /**
        * Calculate birth date from selects
        *
        */

        calculateBirth() {

            if (typeof this.fields.fechaNacimientoDia !== 'undefined' && typeof this.fields.fechaNacimientoMes !== 'undefined' && typeof this.fields.fechaNacimientoAnio !== 'undefined') {

                this.fields.fechaNacimiento = new Date(this.fields.fechaNacimientoAnio, this.fields.fechaNacimientoMes, this.fields.fechaNacimientoDia, 12, 0, 0, 0)

            }

        },

        /**
         * Change form mode reset data
         *
         */

        changeform(id) {

            // Remove alumno data from Prematricula vuex store
            if (this.alumnoId != null) {

                this.removeAlumnoData(this.alumnoId)

            }

            this.personaValidated = false
            this.validation_form_toparent = false
            this.validation_edad_idiomas = false
            this.alumnoId = null

            this.fields = {
                antiguo: id,
                nombre: '',
                apellidos: '',
                dni: '',
                telefono: '',
                fechaNacimiento: '',
                fechaNacimientoDia: undefined,
                fechaNacimientoMes: undefined,
                fechaNacimientoAnio: undefined,
                alumno_idiomas: []
            }

            this.levels = []

            this.$v.$reset()

        },

        /**
         * If is coming from a next tab
         * Clear the levels and the store
         *
         */

        clearPrematriculaStore() {

            this.validation_form_toparent = false
            this.validation_edad_idiomas = false

            // Remove alumno data from Prematricula vuex store
            if (this.alumnoId != null) {

                this.levels = []

                this.removeAlumnoData(this.alumnoId)

            }

        },

        /**
         * Send the form
         *
         */

        async submit() {

            this.$v.$touch()

            if (this.$v.$invalid) {

                this.validation_form = false

            } else {

                this.validation_form = true

            }

            console.log(this.validation_form)

            this.clearPrematriculaStore()

            /**
             * Check edad - languages
             *
             */
            if (this.validation_form) {

                await this.checkEdadSubmit()

            }

            /**
             * If is new alumno create one
             *
             */

            if (this.fields.antiguo == 1 && this.validation_form && this.validation_edad_idiomas) {

                let dd = new Date(this.fields.fechaNacimientoAnio, this.fields.fechaNacimientoMes, this.fields.fechaNacimientoDia, 12, 0, 0, 0)

                let data = {
                    dni: this.fields.dni === '' ? null : this.fields.dni,
                    nombre: this.fields.apellidos + ', ' + this.fields.nombre,
                    telefono: this.fields.telefono,
                    fechaNacimiento: dd,
                }

                // Lets check if this DNI exists
                let checkDni

                if (this.fields.dni === '') {

                    checkDni = false

                } else {

                    checkDni = await this.checkPersona({ dni: data.dni, componentId: this.componentId })

                }

                if (checkDni == false || checkDni && checkDni.esNuevo == true) {


                    // Si no existe
                    if (checkDni == false) {

                        this.personaValidated = await this.createPersona({ data: data, componentId: this.formid })

                    }

                    // Si existe y es nuevo
                    if (checkDni && checkDni.esNuevo == true) {

                        let putRes = await this.putPersona({ id: checkDni.id, componentId: this.formid, data: data })

                        this.personaValidated = putRes.data

                    }

                    this.alumnoId = this.personaValidated.id
                    this.alumnoEdad

                    // Persona to the store personas
                    data.id = this.personaValidated.id
                    data.antiguo = this.fields.antiguo
                    data.previousid = this.personaPrevious

                    this.setPersona(data)

                    this.personaPrevious = this.personaValidated.id

                } else {

                    this.$store.dispatch('Errors/setError', { error: 'CODE28', componentId: this.formid })

                }

            }

            /**
             * Lets get the levels for each language of the alumono
             *
             */

            let idiomas_valid
            let alumno_idiomas_prematricula = false

            /**
             * Check if this alumno is prematriculed in any language
             *
             */

            if (this.validation_edad_idiomas && this.validation_form) {

                try {

                    idiomas_valid = await this.checkPrematriculaIdiomas()

                } catch (error) {

                    this.$store.dispatch('Errors/setError', { error: 'CODE22', componentId: this.formid })

                }

                if (idiomas_valid) {

                    try {

                        alumno_idiomas_prematricula = await this.idiomas()

                    } catch (error) {

                        this.$store.dispatch('Errors/setError', { error: 'CODE14', componentId: this.formid })

                    }

                }

                /**
                 * Lets set the languages in the store Prematricula
                 *
                 */

                try {

                    if (alumno_idiomas_prematricula !== false) {

                        this.alumnoInPrematricula = await this.setAlumnosData(this.levels)

                    }

                } catch (error) {

                    this.$store.dispatch('Errors/setError', { error: 'CODE15', componentId: this.formid })

                }

            }


            /**
             * If data in prematricula && form valid this alumno is ok to go
             *
             */

            if (this.alumnoInPrematricula && this.validation_form != false && this.validation_edad_idiomas) {

                this.validation_form_toparent = true

            } else {

                this.scrollToError()

            }

            this.$emit('getValidation', {
                id: this.formid,
                valid: this.validation_form_toparent
            })

        },

        /**
         * Check if all languages are valid againts age of alumno
         *
         */

        async checkEdadSubmit() {

            if (this.alumnoEdad == 0) {

                this.$store.dispatch('Errors/setError', { error: 'CODE24', componentId: this.formid })
                return false

            }

            if (this.alumnoEdad != false && this.alumnoEdad < this.edadLimite) {

                // Limit for english

                if (this.fields.alumno_idiomas.includes(2) && this.alumnoEdad < this.edadLimiteEnglish) {

                    this.$store.dispatch('Errors/setError', { error: 'CODE24', componentId: this.formid })
                    this.validation_edad_idiomas = false
                    return

                }

                for (let el of this.fields.alumno_idiomas) {

                    if (el !== 2) {

                        this.$store.dispatch('Errors/setError', { error: 'CODE24', componentId: this.formid })
                        this.validation_edad_idiomas = false
                        break

                    }

                    this.validation_edad_idiomas = true
                }

            } else {

                this.validation_edad_idiomas = true

            }

        },

        /**
         * Get the levels for each idioma
         * Store the relations in this.levels
         */

        async idiomas() {

            if (typeof this.alumnoId !== 'undefined') {

                const promises = this.fields.alumno_idiomas.map(async code => {
                    let nivel = await this.getLevel(this.alumnoId, code.idioma.id, this.alumnoEdad, this.getLocalizacion[0].id)

                    let alumnoIdiomaNivel

                    // If nivel null is english
                    if (nivel == null) {

                        alumnoIdiomaNivel = {
                            alumno: this.alumnoId,
                            idioma: code.idioma.id,
                        }

                    } else {

                        alumnoIdiomaNivel = {
                            alumno: this.alumnoId,
                            idioma: code.idioma.id,
                            nivel: nivel.id
                        }

                    }

                    this.levels.push(alumnoIdiomaNivel)

                    return alumnoIdiomaNivel

                })

                const niveles = await Promise.all(promises)

                return niveles

            } else {

                return false

            }

        },

        /**
         * Validate a old student by numeroReferencia
         *
         */

        async alumnoNumeroCheck() {

            this.personaChecking = true
            this.personaCheckError = false
            this.personaValidated = false

            if (isNaN(this.alumnoNumero) || this.alumnoNumero.length > 11) {

                this.personaCheckError = true
                this.personaChecking = false

                return

            }

            this.fields.alumno_idiomas = []

            let dni_check = this.alumnoNumero === '' ? 'undefined' : this.alumnoNumero
            this.personaValidated = await this.checkPersonaReferencia({ codigo: dni_check, componentId: this.formid })

            if (this.personaValidated !== false) {

                this.alumnoId = this.personaValidated.id

                this.fields.fechaNacimiento = this.personaValidated.fechaNacimiento

                let dd = new Date(this.fields.fechaNacimiento)

                this.fields.fechaNacimientoDia = dd.getDate()
                this.fields.fechaNacimientoMes = dd.getMonth()
                this.fields.fechaNacimientoAnio = dd.getFullYear()

                // Persona to the store personas
                let data = {}
                data.id = this.personaValidated.id
                data.previousid = this.personaPrevious
                data.antiguo = this.fields.antiguo
                data.codigo = this.alumnoNumero

                this.setPersona(data)
                this.personaPrevious = this.personaValidated.id

                this.personaCheckError = false

            } else {

                this.fields.alumno_idiomas = []
                this.personaCheckError = true

            }

            /*if(this.getIdiomasFront.length == 0) {

                await this.fetchIdiomas()

            }*/

            this.personaChecking = false

        },

        async checkPrematriculaIdiomas() {

            if (typeof this.alumnoId !== 'undefined') {

                const valididiomas = this.fields.alumno_idiomas.map(async code => {

                    let valid = await this.checkAlumnoPrematricula({ curso: this.getCurso, idalumno: this.alumnoId, ididioma: code.idioma.id })

                    if (valid.data.length == 0) {

                        return Promise.resolve('ok')

                    } else {

                        this.$store.dispatch('Errors/setError', { error: 'CODE27', componentId: this.formid })
                        return Promise.reject(code.idioma.id)

                    }

                })

                const promisesvalididiomas = await Promise.all(valididiomas)

                return promisesvalididiomas

            } else {

                return false

            }

        },

        /**
         * Get nivel for alumno / idioma
         *
         */

        async getLevel(idAlumno, idIdioma, edad, idLocalizacion) {

            try {

                const response = await getNivel(idAlumno, idIdioma, edad, idLocalizacion)

                if (response.statusText == "OK") {

                    return response.data

                } else {

                    return null

                }

            } catch (error) {

                console.log('handle errors' + error)

            }

        }

    }

}

</script>
